<template>

    <v-card :loading="loading" max-width="600">
        <v-card-title>
            <TitleOfDialog title="Upload waypoints" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="form">
                <v-file-input v-model="waypointsFile" color="primary" label="Waypoints file json"
                    accept="application/json" required :rules="waypointsRules">
                </v-file-input> </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn :disabled="loading" @click="validate()" class="w-100" color="primary" variant="elevated"
                text="Upload waypoints"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="js">
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { ref } from 'vue';
import { useVehicleStore } from '@/store/vehicleStore';
import { useNotificationStore } from '@/store/notificationStore';
import { waypointsRules } from '../forms/rules/mission';

const vehicleStore = useVehicleStore();
const form = ref();
const props = defineProps({
    vehicle: Object,
    mission: Object
})

const waypointsFile = ref();
const loading = ref(false);
const emit = defineEmits(['close'])

const validate = async () => {
    const isValid = await form.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            const text = await waypointsFile.value.text();
            const waypointsJson = JSON.parse(text);
            await vehicleStore.importWaypoints(props.mission.id, props.vehicle.id, waypointsJson);
            useNotificationStore().setNotification("Waypoints imported sucessfully", "Waypoints for vehicle " + props.vehicle.name + " has been updated sucessfully.", "mdi-alert", "success");
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}
</script>